import React from 'react';

/**
 * Neutral, unbranded 404 for production hosts. The internal ProjectsPage
 * (the dev project picker) must never be exposed to customers — it now
 * renders only on dev hosts; everywhere else an unknown URL lands here
 * (or on the brand's own NotFound when the path is under a brand base,
 * or redirects to the brand landing on the public domains).
 */
const NotFoundPage = () => (
  <div style={{
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    fontFamily: 'inherit',
  }}>
    <div className="typo-h2">404</div>
    <p className="typo-body" style={{ color: 'var(--color-gray-5)' }}>
      Page not found
    </p>
  </div>
);

export default NotFoundPage;
